import { Outlet } from "react-router-dom";

function NoNavLayout() {
  return (
    <main className="bg-nid_grey px-5 lg:px-20">
      <Outlet></Outlet>
    </main>
  );
}

export default NoNavLayout;
